import { render, staticRenderFns } from "./BarcazaDocumento.vue?vue&type=template&id=53fae8f3"
import script from "./BarcazaDocumento.vue?vue&type=script&lang=js"
export * from "./BarcazaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports